import { BlogPost } from "@/models/blog.model";

import { publicApi } from "../fetch";

export async function createYoutubeBlogPost(id: string) {
  const endpoint = `/blog/youtube/${id}`;
  return publicApi.post<BlogPost>(endpoint);
}
